import { DownOutlined, GlobalOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { useState } from "react";
import { set_language } from "../../locale";

const MenuLang = () => {
  const [defaults, setDefaults] = useState(
    JSON.parse(localStorage.getItem("menu")) || ["0", "2"]
  );

  const setMenu = (index, value) => {
    const menu = localStorage.getItem("menu");
    const keys = menu ? JSON.parse(menu) : defaults;
    keys[index] = value;
    localStorage.setItem("menu", JSON.stringify(keys));
    setDefaults(keys);
  };

  const handleClickMenuLang = (e) => {
    switch (e.key) {
      case "0":
        localStorage.setItem("lang", "es");
        setMenu(0, e.key);
        set_language("es");
        break;
      case "1":
        localStorage.setItem("lang", "en");
        setMenu(0, e.key);
        set_language("en");
        break;
      case "2":
        localStorage.setItem("units", "metrico");
        setMenu(1, e.key);
        break;
      case "3":
        localStorage.setItem("units", "english");
        setMenu(1, e.key);
        break;
    }
    globalThis.location.reload();
  };

  return (
    <Dropdown
      className="mr-4 md:mr-24 hidden md:inline"
      menu={{
        items: [
          { key: 0, label: "Idioma Español", onClick: handleClickMenuLang },
          { key: 1, label: "English Language", onClick: handleClickMenuLang },
          { type: "divider" },
          { key: 2, label: "Sistema Métrico", onClick: handleClickMenuLang },
          { key: 3, label: "English System", onClick: handleClickMenuLang },
        ],
      }}
    >
      <button
        className="ant-dropdown-link text-white  hover:text-black bg-transparent border-0 cursor-pointer"
        onClick={(e) => e.preventDefault()}
      >
        <Space>
          <GlobalOutlined />
          <DownOutlined />
        </Space>
      </button>
    </Dropdown>
  );
};

export default MenuLang;
